import React from 'react';

// Propsの型を定義します。
interface MessageComponentProps {
    message: string;
    maxLength?: number; // maxLengthはオプショナルで、デフォルトは60です。
}

const MessageComponent: React.FC<MessageComponentProps> = ({
                                                               message,
                                                               maxLength = 60
                                                           }) => {
    // メッセージがmaxLengthより長い場合は、指定された文字数でカットして「…」を追加します。
    // そうでない場合は、メッセージをそのまま表示します。
    let displayMessage = "";
    if(message) {
        displayMessage =
            message.length > maxLength ? message.substring(0, maxLength) + '…' : message;
    }

    return <span>{displayMessage}</span>;
};

export default MessageComponent;
